// extracted by mini-css-extract-plugin
module.exports = {"EmptyOverlay":"src-components-Calendar-EmptyOverlay-styles__EmptyOverlay--1pTHZ","EmptyOverlayWithPlan":"src-components-Calendar-EmptyOverlay-styles__EmptyOverlayWithPlan--1ZM4U"};